import { Box, Typography } from "@mui/material";
import { colors } from "../../../../../ui/colors";

export const Row = ({ label, value }: { label: string; value: any }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
    <Typography sx={{ fontSize: 14, color: colors.gray[800] }}>{label}</Typography>
    <Typography sx={{ fontSize: 14 }}>{value ?? "-"}</Typography>
  </Box>
);